module.exports = __webpack_public_path__ + "static/media/renovation.b32d6be8.png";